import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function CategoryNav() {
  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16">
      <div className="mb-8">
        <h3 className="text-2xl md:text-3xl font-bold font-heading text-foreground-50 mb-2">
          电影分类
        </h3>
        <p className="text-sm text-foreground-500">探索不同类型的精彩电影，发现你的最爱</p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group flex flex-col items-center gap-3 p-5 md:p-6 rounded-xl bg-background-100 hover:bg-background-200 transition-all duration-300 border border-background-200/50 hover:border-primary-500/30 cursor-pointer"
          >
            <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-500/10 group-hover:bg-primary-500/20 transition-colors">
              <i className={`${cat.icon} text-xl md:text-2xl text-primary-500`}></i>
            </div>
            <div className="text-center">
              <span className="block text-sm md:text-base font-medium text-foreground-100 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
              <span className="block text-xs text-foreground-600 mt-0.5">
                {cat.count}部
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}